<template>
    <div class="personal-info">
        <h1 class="title">个人信息</h1>
        <div class="info-container">
            <el-form ref="info_form" :model="info_form" label-width="90px" class="user-info" :rules="info_rules">
                <el-form-item label="照片" style="position:relative;">

                    <div class="head-sculpture">
                        <img slot="trigger" v-if="imageUrl" :src="imageUrl" class="upload-img">
                        <img slot="trigger" v-if="headUrl&&!imageUrl" :src="getImgSrc2(headUrl)" class="upload-img">
                        <img slot="trigger" v-if="!headUrl&&!imageUrl" src="../../../../assets/head-sculpture.png" class="upload-img">

                        <div style="" class="head-info">
                            <p>照片要求:</p>
                            <p>1.近期正面免冠彩色头像, 头部占照片尺寸的2/3 </p>
                            <p>2.白色背景无边框 </p>
                            <p>3.人像清晰，层次丰富，神态自然，无明显畸变 </p>
                            <p>4.照片尺寸为358px × 441px, 格式为.png或.jpg</p>
                            <p>5.照片大小小于2M</p>
                        </div>
                         <el-upload class="upload-head" :action="uploadPhoto()" :show-file-list="false" :on-success="handleImgSuccess" :before-upload="beforeImgUpload" >
                            <!-- :src="../../../../assets/head-sculpture.png" -->
                            <el-button slot="trigger" type="primary">上传头像</el-button>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item label="姓名" prop="userName">
                    <div class="nickname">
                        <p style="position:relative;top:-15px;left:10px;">{{userName}}</p>
                    </div>
                </el-form-item>
                <!-- <el-form-item label="昵称" prop="nickName">
          <div class="nickname">
            <el-input v-model="info_form.nickName" placeholder="请输入内容"></el-input>
            <el-button type="primary" @click="chooseName">为我挑一个</el-button>
          </div>
        </el-form-item> -->
                <el-form-item label="性别" class="sex-item" prop="sex">
                    <el-radio-group class="sex" v-model="info_form.sex">
                        <el-radio label="男">
                            <img src="../../../../assets/sex-male.png">
                        </el-radio>
                        <el-radio label="女" style="margin-left:30px;">
                            <img src="../../../../assets/sex-female.png">
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- <el-form-item label="生日">
          <div class="birthday">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="info_form.birthDate"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </el-form-item> -->
                <!-- <el-form-item label="兴趣方向">
          <div class="interests">
            <p
              style="font-size:16px;color:#999999;margin:0;margin-bottom:10px;"
            >请选择您感兴趣的分类，便于给您精准的推荐。</p>
            <el-checkbox-group v-model="info_form.checkedInterests">
              <el-checkbox
                v-for="(inter,index) in info_form.interestsOptions"
                :label="inter.uuid"
                :key="index"
                border
              >{{inter.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item> -->
                <el-form-item label="部门" prop="department" style="margin-bottom:20px;" class="department-style">
                    <el-cascader style="width:400px;" :placeholder="belongtoDep" :options="depList" v-model="info_form.myDep" :props="props" :show-all-levels="true">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="岗位" prop="job" style="margin-bottom:20px;">
                    <el-select v-model="info_form.job" placeholder="请选择岗位">
                        <el-option v-for="item in jobList" :key="item.name" :label="item.name" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="button-margin">
                    <el-button type="primary" @click="saveInfo">保存</el-button>
                </el-form-item>
                <!-- <el-form-item label="邮箱" prop="email">
          <div class="email">
            <el-input v-model="info_form.email"></el-input>
          </div>
        </el-form-item> -->
                <!-- <h3 class="other-info">
          其它信息
          <span style="color:#999999;margin-left:10px;font-weight:normal">我们将严格为你保密</span>
        </h3>
        <el-form-item label="婚姻状况">
          <div class="marriage">
            <el-radio-group v-model="info_form.marry">
              <el-radio label="3">已婚</el-radio>
              <el-radio label="6">未婚</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="月收入">
          <div class="more-info">
            <el-select v-model="info_form.incomeValue">
              <el-option
                v-for="item in monthlyIncome"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="教育程度">
          <div class="more-info">
            <el-select v-model="info_form.education">
              <el-option
                v-for="item in educationalLevel"
                :key="item.dictValue"
                :label="item.name"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="所在行业">
          <div class="more-info" style="margin-bottom:105px;">
            <el-select v-model="info_form.profession">
              <el-option
                v-for="item in industry"
                :key="item.dictValue"
                :label="item.name"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </div>
        </el-form-item> -->
            </el-form>
        </div>
    </div>
</template>
<script>
// const interestsOptions = [
//   "英语教育培训",
//   "空中交通管制",
//   "运输航空飞行",
//   "航空维修",
//   "航空驾驶",
//   "航空安全",
//   "飞行通讯",
//   "飞行签派",
//   "飞行机械",
//   "情报",
//   "领航",
//   "气象",
//   "电信"
// ];
const randomNickName = [
    '蓝若天',
    '小飞侠',
    '飞行媛',
    '冉冉蔚蓝',
    '哥伦比亚号',
    '冲上云霄',
    '小蓝',
    '小飞',
    '管管',
    '飞飞',
    '机长',
    '小小飞行员',
]
let choose = 0
import Bus from "@/utils/Bus"
export default {
    data() {
        var checkEmail = (rule, value, callback) => {
            var myReg = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/
            if (value.length > 30) {
                callback(new Error('邮箱长度过长'))
            } else if (myReg.test(value) || value.length === 0) {
                callback()
            } else {
                callback(new Error('邮箱格式不正确'))
            }
        }
        var checkNickName = (rule, value, callback) => {
            if (value.length > 50) {
                callback(new Error('昵称长度过长'))
            } else if (value.length === 0) {
                callback(new Error('昵称不能为空'))
            } else {
                callback()
            }
        }
        // var checkDep = (rule, value, callback) => {
        //   if (this.info_form.myDep.length <= 0) {
        //     callback(new Error('请选择您的部门'))
        //   } else {
        //     callback()
        //   }
        // }
        return {
            monthlyIncome: [
                { label: '2000-3000', value: '2000-3000' },
                { label: '3000-5000', value: '3000-5000' },
                { label: '5000-10000', value: '5000-10000' },
                { label: '10000以上', value: '10000以上' },
            ],
            depList: [],
            jobList: [],
            belongtoDep: '',
            imageUrl: '',
            educationalLevel: [],
            industry: [],
            headUrl: '',
            userName: '',
            info_form: {
                // userName: '',
                myDep: [],
                job: '',
                sex: '',
                checkedInterests: [],
                interestsOptions: [],
                marry: '',
                nickName: '',
                birthDate: '',
                email: '',
                incomeValue: '',
                education: '',
                profession: '',
            },
            props: {
                value: 'id',
                label: 'departmentName',
                children: 'childEnterpriseList',
            },
            info_rules: {
                // nickName: [{ validator: checkNickName, trigger: "blur" }],
                sex: [
                    {
                        required: true,
                        message: '请选择您的性别',
                        trigger: 'blur',
                    },
                ],
                // userName: [
                //   { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                // ],
                // department: [{ required: true, validator: checkDep, trigger: 'blur' }],
                email: [{ validator: checkEmail, trigger: 'blur' }],
                // job: [{ required: true, message: '请选择您的岗位', trigger: 'blur' }]
            },
        }
    },
    created() {
        this.getDepartmentList()
        this.getJobList()
        this.getUserDep()
        if (sessionStorage.token === '' || sessionStorage.token === undefined) {
            this.$message.info('请先登录')
            this.$router.push('/login')
        }
        this.$ajax
            .post('/auth-config-service/dict/getKeyAll?key=interest')
            .then((res) => {
                this.info_form.interestsOptions = res.data
                this.$ajax
                    .post(
                        '/auth-config-service/dict/getKeyAll?key=EducationalLevel'
                    )
                    .then((res) => {
                        this.educationalLevel = res.data
                        this.$ajax
                            .post(
                                '/auth-config-service/dict/getKeyAll?key=Industry'
                            )
                            .then((res) => {
                                this.industry = res.data
                            })
                    })
            })
        this.$ajax
            .post(
                '/comuser-service/Account/seeAccount',
                this.postData({
                    id: sessionStorage.userUuid,
                })
            )
            .then((res) => {
                this.info_form.job = res.data.tbAccount.jobType
                this.userName = res.data.tbAccount.userName
                if (res.data.tbUser.birthdayMonth < 10) {
                    res.data.tbUser.birthdayMonth =
                        '0' + res.data.tbUser.birthdayMonth
                } else if (res.data.tbUser.birthdayDay < 10) {
                    res.data.tbUser.birthdayDay =
                        '0' + res.data.tbUser.birthdayDay
                }
                this.info_form.sex = res.data.tbUser.userSex
                this.headUrl = res.data.tbUser.photoUrl
                if (this.headUrl === '"null"') {
                    this.headUrl = ''
                }
                this.info_form.nickName = res.data.tbAccount.nickName
                if (
                    !res.data.tbUser.birthdayYear ||
                    !res.data.tbUser.birthdayMonth ||
                    !res.data.tbUser.birthdayDay
                ) {
                    this.info_form.birthDate = ''
                } else {
                    this.info_form.birthDate =
                        res.data.tbUser.birthdayYear +
                        '-' +
                        res.data.tbUser.birthdayMonth +
                        '-' +
                        res.data.tbUser.birthdayDay
                }

                for (var i = 0; i < res.data.interests.length; i++) {
                    this.$set(
                        this.info_form.checkedInterests,
                        i,
                        res.data.interests[i].interestId
                    )
                }
                this.info_form.email = res.data.tbAccount.emailAddress
                this.info_form.marry =
                    res.data.tbUser.marriageStatus !== null
                        ? res.data.tbUser.marriageStatus.toString()
                        : ''
                this.info_form.incomeValue = res.data.tbUser.monthlyProfit
                    ? res.data.tbUser.monthlyProfit
                    : ''
                this.info_form.education = res.data.tbUser.educationalStatus
                    ? res.data.tbUser.educationalStatus
                    : ''
                this.info_form.profession = res.data.tbUser.industry
                    ? res.data.tbUser.industry
                    : ''
            })
    },
    methods: {
        getUserDep() {
            let data = {}
            data.userId = sessionStorage.userUuid
            this.$ajax
                .post(
                    '/enterprise-service/enterpriseUser/getDepUsersByDepId',
                    this.postData({
                        data: JSON.stringify(data),
                    })
                )
                .then((res) => {
                    this.belongtoDep = res.data[0].departmentName
                    let myDep = res.data[0].fids.split('/')
                    myDep.splice(0, 1)
                    this.info_form.myDep = myDep
                })
        },
        getJobList() {
            this.$ajax
                .post(
                    '/auth-config-service/dict/getKeyAll',
                    this.postData({
                        key: 'postType',
                    })
                )
                .then((res) => {
                    this.jobList = res.data
                })
        },
        getDepartmentList() {
            this.$ajax
                .get(
                    '/enterprise-service/Enterprise/getEnterpriseStructure?id=AB294720967E451A8EC0173606CE0650'
                )
                .then((res) => {
                    this.depList = res.data.childEnterpriseList
                    // this.depList[0].departmentName = this.depList[0].enterpriseName
                    // console.log('depList', this.depList)
                })
        },
        getImgSrc2(url) {
            if (url) {
                // let first = url.lastIndexOf(":");
                // let last = url.lastIndexOf('"');
                // let finalUrl = url.substring(first + 2, last);
                return this.filesDownload(url)
            } else {
                return
            }
        },
        handleImgSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw)
            this.headUrl = res.data
        },
        beforeImgUpload(file) {
            const isJPG = file.type === 'image/jpeg'
            const isPNG = file.type === 'image/png'
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG && !isPNG) {
                this.$message.error('上传图片只能是 JPG或PNG 格式!')
                return false
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!')
                return false
            }
            return true
        },
        saveInfo() {
            this.$refs['info_form'].validate((valid) => {
                if (valid) {
                    let birthday = this.info_form.birthDate
                    let interestID = []
                    for (var i in this.info_form.checkedInterests) {
                        interestID[i] = this.info_form.checkedInterests[i]
                    }
                    let tbAccount = {
                        id: sessionStorage.userUuid,
                        emailAddress: this.info_form.email,
                        nickName: this.info_form.nickName,
                        jobType: this.info_form.job,
                    }
                    let tbUser = {
                        userSex: this.info_form.sex,
                        birthdayYear: birthday.slice(0, 4),
                        birthdayMonth: birthday.slice(5, 7),
                        birthdayDay: birthday.slice(8, 10),
                        marriageStatus: this.info_form.marry,
                        monthlyProfit: this.info_form.incomeValue,
                        educationalStatus: this.info_form.education,
                        industry: this.info_form.profession,
                        photoUrl: this.headUrl,
                    }
                    let tbUserInterest = { interestId: interestID }
                    this.$ajax
                        .post(
                            '/comuser-service/Account/updateUser',
                            this.postData({
                                tbAccount1: JSON.stringify(tbAccount),
                                tbUser1: JSON.stringify(tbUser),
                                tbUserInterest1: JSON.stringify(tbUserInterest),
                            })
                        )
                        .then((res) => {
                            let data = []
                            data.push({
                                accountId: sessionStorage.userUuid,
                                departmentId: this.info_form.myDep[
                                    this.info_form.myDep.length - 1
                                ],
                            })
                            this.$ajax
                                .post(
                                    '/enterprise-service/enterpriseUser/updateUsersDep',
                                    this.postData({
                                        data: JSON.stringify(data),
                                        enterpriseId:
                                            'AB294720967E451A8EC0173606CE0650',
                                    })
                                )
                                .then((res) => {
                                    Bus.$emit('updateUsersDep')//修改成功后，更新头部头像显示
                                    this.$message({
                                        message: '个人信息保存成功！',
                                        type: 'success',
                                    })
                                    setTimeout(() => {
                                        sessionStorage.hasChecked = 'basic'
                                        // this.$router.push('/SaftySetting/SetInfo')
                                    }, 1000)
                                })
                        })
                }
            })
        },
        chooseName() {
            var i = Math.floor(Math.random() * randomNickName.length + 1) - 1
            if (choose != i) {
                this.info_form.nickName = randomNickName[i]
                choose = i
            } else {
                this.chooseName()
            }
        },
    },
}
</script>
<style lang="scss">
.personal-info {
    width: 1020px;
    background: rgb(255, 255, 255);
    margin-left: 35px;
    .department-style {
        input::-webkit-input-placeholder {
            color: #333333;
        }
    }
    .head-info {
        position: absolute;
        font-size: 12px;
        top: 18px;
        left: 220px;
        p {
            margin: 0;
            line-height: 14px;
            margin-bottom: 10px;
            color: #666666;
        }
    }
    .el-form-item {
        margin: 0;
    }
    .title {
        font-weight: normal;
		font-size: 16px;
		margin: 15px 0 25px;
		color: #333333;
        font-weight: bold;
        border-bottom: 1px solid #cccccc;
        padding: 0 00px 10px;
        margin-left: 10px;
    }
    .info-container {
        margin: 0 40px;
        .save-info {
            width: 100%;
            height: 60px;
            background-color: #e5f1fb;
            border-top: 1px #c3d6ec solid;
            .el-button {
                font-size: 16px;
                background-color: #1060ab;
                width: 100px;
                padding: 10px 35px;
                border-color: #1060ab;
                float: right;
                margin: 10px;
            }
        }
        .other-info {
            font-size: 16px;
            color: #333333;
            padding-bottom: 10px;
            padding-left: 10px;
            border-bottom: 1px #eeeeee solid;
            margin: 0;
            margin-top: 25px;
            margin-bottom: 35px;
        }
        .user-info {
            .el-form-item__error {
                top: 35px;
                left: 5px;
            }
            .head-sculpture {
                margin-bottom: 30px;
                margin-left: 40px;
                .el-button {
                    width: 135px;
                    padding: 8px 15px;
                    font-size: 14px;
                    background-color: #eeeeee;
                    border-color: #dcdcdc;
                    color: #333333;
                    position: relative;
                    // top: -60px;
                }
                .upload-img {
                    height: 167px;
                    width: 135px;
                    // border-radius: 50%;
                }
            }
            .nickname {
                margin-bottom: 20px;
                .el-button {
                    padding: 8px 15px;
                    font-size: 14px;
                    background-color: #eeeeee;
                    border-color: #dcdcdc;
                    color: #333333;
                }
                .el-input {
                    width: 350px;
                    margin: 0 5px;
                }
                .el-input__inner {
                    height: 32px;
                }
            }
            .sex-item {
                .el-form-item__error {
                    top: 48px;
                    left: 5px;
                }
            }
            .sex {
                margin-left: 5px;
                margin-bottom: 25px;
                .el-radio__input {
                    position: relative;
                    top: -15px;
                }
            }
            .birthday {
                margin-left: 5px;
                margin-bottom: 40px;
                .el-date-editor {
                    width: 350px;
                }
                .el-input__inner {
                    height: 32px;
                }
            }
            .interests {
                margin-left: 5px;
                .el-checkbox-group {
                    width: 700px;
                    margin-bottom: 35px;
                }
                .el-checkbox__inner {
                    display: none;
                }
                .el-checkbox__label {
                    padding: 0;
                }
                .el-checkbox.is-bordered {
                    padding: 0;
                    height: 30px;
                    width: 120px;
                    text-align: center;
                    line-height: 30px;
                    margin: 0;
                    margin-right: 15px;
                }
                .el-checkbox.is-bordered.is-checked {
                    border-color: #409eff;
                }
                .el-checkbox__input.is-checked + .el-checkbox__label {
                    color: #409eff;
                }
            }
            .email {
                margin-left: 5px;
                margin-bottom: 70px;
                .el-input {
                    width: 350px;
                    margin: 0 5px;
                }
                .el-input__inner {
                    height: 32px;
                }
            }
            .marriage {
                margin-left: 5px;
                margin-bottom: 20px;
            }
            .more-info {
                margin-left: 5px;
                margin-bottom: 20px;
                .el-input {
                    width: 350px;
                    margin: 0 5px;
                }
                .el-input__inner {
                    height: 32px;
                }
            }
            .button-margin {
                .el-form-item__content {
                    margin-left: 50px !important;
                }
                .el-button {
                    background-color: #1060ab;
                    border-color: #1060ab;
                    font-size: 16px;
                    width: 80px;
                    height: 30px;
                    line-height: 5px;
                }
            }
        }
        .sex-item {
            .el-form-item__label {
                position: relative;
                top: 7px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/accountInfo/personaInfo.vue